<template>
  <div class="container">
    <ali-player :source="source" :autoplay="true"></ali-player>
  </div>
</template>

<script>
import VueAliplayer from "vue-aliplayer-v2";
export default {
  components: {
    "ali-player": VueAliplayer,
  },
  data() {
    return {
      source: null,
    };
  },
  mounted() {
    const params = this.$route.params;
    this.source = params.source;
    document.title = params.title;
  },
  methods: {},
};
</script>

<style>
.container {
  padding: 12px;
}
</style>